import { networkActionsCreator } from '../../../../admincore'

const actions = {
  ...networkActionsCreator('scheduledOrders'),
}

export default actions

export function load(params) {
  return {
    type: actions.LOAD,
    payload: {
      params,
    },
  }
}
